import { c as _c } from "react/compiler-runtime";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@shared-components/shadcn/chart";
import { Bar, CartesianGrid, XAxis, YAxis, Legend, BarChart } from "recharts";
import { api } from "@shared-server/api";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
type ProfilesContentProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};
const chartConfig: ChartConfig = {
  count: {
    label: "Profiels content"
  }
};
export const ProfilesContent = props => {
  const $ = _c(17);
  let t0;
  if ($[0] !== props.endDate || $[1] !== props.granularity || $[2] !== props.startDate) {
    t0 = {
      dateStart: props.startDate,
      dateEnd: props.endDate,
      granularity: props.granularity
    };
    $[0] = props.endDate;
    $[1] = props.granularity;
    $[2] = props.startDate;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    data
  } = api.coreMetrics.profilesContent.useQuery(t0);
  let t1;
  if ($[4] !== data) {
    t1 = data || [];
    $[4] = data;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const chartData = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mb-4">{chartConfig.count?.label}</h2>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CartesianGrid vertical={false} />;
    t4 = <XAxis dataKey="date" xAxisId="date" tickLine={false} axisLine={false} tickMargin={8} />;
    t5 = <YAxis interval={1} tickLine={false} axisLine={false} orientation="left" allowDecimals={false} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChartTooltip content={<ChartTooltipContent className="w-[150px]" nameKey="date" labelFormatter={_temp} />} />;
    t7 = <Legend />;
    t8 = <Bar yAxisId={0} xAxisId="date" dataKey="hasAttachedContextFiles" className="fill-ter-blue-500" fill="#006e96" name="Attached Context Files Count" />;
    t9 = <Bar yAxisId={0} xAxisId="date" dataKey="hasEnabledTools" className="fill-ter-yellow-600" fill="#eaaa00" name="Enabled Tools Count" />;
    t10 = <Bar yAxisId={0} xAxisId="date" dataKey="profilesCreated" className="fill-ter-mint-500" fill="#53b692" name="Profiles Created" />;
    $[10] = t10;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] !== chartData) {
    t11 = <div>{t2}<ChartContainer config={chartConfig} className="aspect-auto h-[150px] w-full"><BarChart accessibilityLayer={true} data={chartData}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</BarChart></ChartContainer></div>;
    $[15] = chartData;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
function _temp(value) {
  return value;
}